import React from "react";

const THRESHOLD = 16;

export function useIsScrolledToTop({
  disabled = false,
}: { disabled?: boolean } = {}) {
  const [state, setState] = React.useState<boolean>();

  React.useEffect(() => {
    if (disabled) return;
    setState(window.scrollY < THRESHOLD);
    return () => setState(undefined);
  }, [disabled]);

  React.useEffect(() => {
    if (disabled) return;
    const refresh = () => {
      const newState = window.scrollY < THRESHOLD;
      state !== newState && setState(newState);
    };
    window.addEventListener("scroll", refresh);
    return () => window.removeEventListener("scroll", refresh);
  }, [disabled, state]);

  return state;
}
